import script from "./tutorOnboardingThirdPage.vue?vue&type=script&setup=true&lang=js"
export * from "./tutorOnboardingThirdPage.vue?vue&type=script&setup=true&lang=js"

import "./tutorOnboardingThirdPage.vue?vue&type=style&index=0&id=ab10e410&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab10e410"]])

export default __exports__